import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/study-helpers/$studyHelperId')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/admin/people/$userId/',
      params: { userId: params.studyHelperId },
    });
  },
});
